import { mapActions, mapGetters, mapMutations } from "vuex";
import { dynamicHead } from "../../../../mixins/dynamic-head";
export default {
    name: "news-detail",
    data() {
        return {
            params: {
                title: "",
                description: "",
                keywords: "",
                image: "",
                name: "",
            },
        };
    },
    mixins: [dynamicHead],

    watch: {
        "$route.path"() {
            this.fetchData({ slug: this.$route.params.slug }).then(() => {
                this.fetchRandomList({ id: this.currentItem.id });
            });
        },
    },
    computed: {
        ...mapGetters({
            currentItem: "articles/articlesItem",
            currentItemLoading: "articles/articlesItemLoading",
            randomList: "articles/randomArticlesList",
            randomListLength: "articles/randomArticlesListLength",
            randomListLoading: "articles/randomArticlesListLoading",
        }),
    },
    mounted() {},
    created() {
        this.fetchData({ slug: this.$route.params.slug }).then(() => {
            this.fetchRandomList({ id: this.currentItem.id }).then(() => {
                this.setPageItem(this.currentItem);
            });
        });
    },
    methods: {
        ...mapActions({
            fetchData: "articles/GET_ARTICLES_ITEM",
            fetchRandomList: "articles/GET_RANDOM_ARTICLES_LIST",
        }),
        ...mapMutations({
            setCurrentItem: "articles/SET_ARTICLES_ITEM",
            setRandomList: "articles/SET_RANDOM_ARTICLES_LIST",
        }),
    },
};
